import React from 'react'
import PropTypes from 'prop-types'
import { CheckboxGroup, InputLabel } from 'lp-components'
import DropdownSelect from './dropdown-select'

function DropdownCheckboxGroup(props) {
  const {
    input: { name, value },
    label,
    selectedValues,
    placeholder,
    'aria-label': ariaLabel,
  } = props
  const val = value === '' ? [] : value
  const triggerAriaLabel =
    ariaLabel || (typeof label === 'string' ? label : `Toggle ${name} options`)
  return (
    <fieldset aria-label={ariaLabel || undefined}>
      <InputLabel {...{ label, name }} />
      <DropdownSelect
        selectedValues={selectedValues || val}
        placeholder={placeholder}
        triggerAriaLabel={triggerAriaLabel}
      >
        <CheckboxGroup {...props} label={false} />
      </DropdownSelect>
    </fieldset>
  )
}

DropdownCheckboxGroup.propTypes = { ...(CheckboxGroup.propTypes || {}) }
DropdownCheckboxGroup.propTypes['aria-label'] = PropTypes.string
DropdownCheckboxGroup.propTypes.label = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.node,
])

export default DropdownCheckboxGroup
